<template>
  <div>
    <!-- 这个组件不会显示任何内容，只是用于重定向 -->
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'Exception404Redirect',
  mounted() {
    // 检查用户是否已登录（通过token判断）
    const token = storage.get(ACCESS_TOKEN)
    
    if (token) {
      // 已登录用户重定向到首页
      this.$router.replace('/home/page')
    } else {
      // 未登录用户重定向到登录页面
      this.$router.replace('/user/login')
    }
  }
}
</script>

<style scoped>

</style> 